// extracted by mini-css-extract-plugin
export default {"label":"DatosUuid_label__t6vSo","title":"DatosUuid_title__ZMoLg","button":"DatosUuid_button__Lj4zZ","info":"DatosUuid_info__PZs6U"};